import * as yup from 'yup'

export const archiveReasonSchema = yup.object({
  reasonType: yup
    .string()
    .oneOf(['other', 'churn'])
    .required('Motivo do arquivamento é obrigatório'),
  notes: yup.string()
})

export type ArchiveReasonFormData = yup.InferType<typeof archiveReasonSchema>
